"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryLetRef = exports.AliasRef = exports.Query = exports.SortClause = exports.ReturnClause = exports.ByColumn = exports.ByExpression = exports.ByDirection = exports.Sort = exports.Without = exports.With = exports.LetClause = exports.AliasedQuerySource = void 0;
var expression_1 = require("./expression");
var context_1 = require("../runtime/context");
var util_1 = require("../util/util");
var comparison_1 = require("../util/comparison");
var builder_1 = require("./builder");
var AliasedQuerySource = /** @class */ (function () {
    function AliasedQuerySource(json) {
        this.alias = json.alias;
        this.expression = (0, builder_1.build)(json.expression);
    }
    return AliasedQuerySource;
}());
exports.AliasedQuerySource = AliasedQuerySource;
var LetClause = /** @class */ (function () {
    function LetClause(json) {
        this.identifier = json.identifier;
        this.expression = (0, builder_1.build)(json.expression);
    }
    return LetClause;
}());
exports.LetClause = LetClause;
var With = /** @class */ (function (_super) {
    __extends(With, _super);
    function With(json) {
        var _this = _super.call(this, json) || this;
        _this.alias = json.alias;
        _this.expression = (0, builder_1.build)(json.expression);
        _this.suchThat = (0, builder_1.build)(json.suchThat);
        return _this;
    }
    With.prototype.exec = function (ctx) {
        var _this = this;
        var records = this.expression.execute(ctx);
        if (!(0, util_1.typeIsArray)(records)) {
            records = [records];
        }
        var returns = records.map(function (rec) {
            var childCtx = ctx.childContext();
            childCtx.set(_this.alias, rec);
            return _this.suchThat.execute(childCtx);
        });
        return returns.some(function (x) { return x; });
    };
    return With;
}(expression_1.Expression));
exports.With = With;
var Without = /** @class */ (function (_super) {
    __extends(Without, _super);
    function Without(json) {
        return _super.call(this, json) || this;
    }
    Without.prototype.exec = function (ctx) {
        return !_super.prototype.exec.call(this, ctx);
    };
    return Without;
}(With));
exports.Without = Without;
// ELM-only, not a product of CQL
var Sort = /** @class */ (function (_super) {
    __extends(Sort, _super);
    function Sort() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Sort;
}(expression_1.UnimplementedExpression));
exports.Sort = Sort;
var ByDirection = /** @class */ (function (_super) {
    __extends(ByDirection, _super);
    function ByDirection(json) {
        var _this = _super.call(this, json) || this;
        _this.direction = json.direction;
        _this.low_order = _this.direction === 'asc' || _this.direction === 'ascending' ? -1 : 1;
        _this.high_order = _this.low_order * -1;
        return _this;
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    ByDirection.prototype.exec = function (ctx, a, b) {
        if (a === b) {
            return 0;
        }
        else if (a.isQuantity && b.isQuantity) {
            if (a.before(b)) {
                return this.low_order;
            }
            else {
                return this.high_order;
            }
        }
        else if (a < b) {
            return this.low_order;
        }
        else {
            return this.high_order;
        }
    };
    return ByDirection;
}(expression_1.Expression));
exports.ByDirection = ByDirection;
var ByExpression = /** @class */ (function (_super) {
    __extends(ByExpression, _super);
    function ByExpression(json) {
        var _this = _super.call(this, json) || this;
        _this.expression = (0, builder_1.build)(json.expression);
        _this.direction = json.direction;
        _this.low_order = _this.direction === 'asc' || _this.direction === 'ascending' ? -1 : 1;
        _this.high_order = _this.low_order * -1;
        return _this;
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    ByExpression.prototype.exec = function (ctx, a, b) {
        var sctx = ctx.childContext(a);
        var a_val = this.expression.execute(sctx);
        sctx = ctx.childContext(b);
        var b_val = this.expression.execute(sctx);
        if (a_val === b_val || (a_val == null && b_val == null)) {
            return 0;
        }
        else if (a_val == null || b_val == null) {
            return a_val == null ? this.low_order : this.high_order;
        }
        else if (a_val.isQuantity && b_val.isQuantity) {
            return a_val.before(b_val) ? this.low_order : this.high_order;
        }
        else {
            return a_val < b_val ? this.low_order : this.high_order;
        }
    };
    return ByExpression;
}(expression_1.Expression));
exports.ByExpression = ByExpression;
var ByColumn = /** @class */ (function (_super) {
    __extends(ByColumn, _super);
    function ByColumn(json) {
        var _this = _super.call(this, json) || this;
        _this.expression = (0, builder_1.build)({
            name: json.path,
            type: 'IdentifierRef'
        });
        return _this;
    }
    return ByColumn;
}(ByExpression));
exports.ByColumn = ByColumn;
var ReturnClause = /** @class */ (function () {
    function ReturnClause(json) {
        this.expression = (0, builder_1.build)(json.expression);
        this.distinct = json.distinct != null ? json.distinct : true;
    }
    return ReturnClause;
}());
exports.ReturnClause = ReturnClause;
var SortClause = /** @class */ (function () {
    function SortClause(json) {
        this.by = (0, builder_1.build)(json != null ? json.by : undefined);
    }
    SortClause.prototype.sort = function (ctx, values) {
        var _this = this;
        if (this.by) {
            return values.sort(function (a, b) {
                var order = 0;
                for (var _i = 0, _a = _this.by; _i < _a.length; _i++) {
                    var item = _a[_i];
                    // Do not use execute here because the value of the sort order is not important.
                    order = item.exec(ctx, a, b);
                    if (order !== 0) {
                        break;
                    }
                }
                return order;
            });
        }
    };
    return SortClause;
}());
exports.SortClause = SortClause;
var toDistinctList = function (xList) {
    var yList = [];
    xList.forEach(function (x) {
        if (!yList.some(function (y) { return (0, comparison_1.equals)(x, y); })) {
            yList.push(x);
        }
    });
    return yList;
};
var AggregateClause = /** @class */ (function (_super) {
    __extends(AggregateClause, _super);
    function AggregateClause(json) {
        var _this = _super.call(this, json) || this;
        _this.identifier = json.identifier;
        _this.expression = (0, builder_1.build)(json.expression);
        _this.starting = json.starting ? (0, builder_1.build)(json.starting) : null;
        _this.distinct = json.distinct != null ? json.distinct : true;
        return _this;
    }
    AggregateClause.prototype.aggregate = function (returnedValues, ctx) {
        var _this = this;
        var aggregateValue = this.starting != null ? this.starting.exec(ctx) : null;
        returnedValues.forEach(function (contextValues) {
            var childContext = ctx.childContext(contextValues);
            childContext.set(_this.identifier, aggregateValue);
            aggregateValue = _this.expression.exec(childContext);
        });
        return aggregateValue;
    };
    return AggregateClause;
}(expression_1.Expression));
var Query = /** @class */ (function (_super) {
    __extends(Query, _super);
    function Query(json) {
        var _this = _super.call(this, json) || this;
        _this.sources = new MultiSource(json.source.map(function (s) { return new AliasedQuerySource(s); }));
        _this.letClauses = json.let != null ? json.let.map(function (d) { return new LetClause(d); }) : [];
        _this.relationship = json.relationship != null ? (0, builder_1.build)(json.relationship) : [];
        _this.where = (0, builder_1.build)(json.where);
        _this.returnClause = json.return != null ? new ReturnClause(json.return) : null;
        _this.aggregateClause = json.aggregate != null ? new AggregateClause(json.aggregate) : null;
        _this.aliases = _this.sources.aliases();
        _this.sortClause = json.sort != null ? new SortClause(json.sort) : null;
        return _this;
    }
    Query.prototype.isDistinct = function () {
        if (this.aggregateClause != null && this.aggregateClause.distinct != null) {
            return this.aggregateClause.distinct;
        }
        else if (this.returnClause != null && this.returnClause.distinct != null) {
            return this.returnClause.distinct;
        }
        return true;
    };
    Query.prototype.exec = function (ctx) {
        var _this = this;
        var returnedValues = [];
        this.sources.forEach(ctx, function (rctx) {
            for (var _i = 0, _a = _this.letClauses; _i < _a.length; _i++) {
                var def = _a[_i];
                rctx.set(def.identifier, def.expression.execute(rctx));
            }
            var relations = _this.relationship.map(function (rel) {
                var child_ctx = rctx.childContext();
                return rel.execute(child_ctx);
            });
            var passed = (0, util_1.allTrue)(relations) && (_this.where ? _this.where.execute(rctx) : true);
            if (passed) {
                if (_this.returnClause != null) {
                    var val = _this.returnClause.expression.execute(rctx);
                    returnedValues.push(val);
                }
                else {
                    if (_this.aliases.length === 1 && _this.aggregateClause == null) {
                        returnedValues.push(rctx.get(_this.aliases[0]));
                    }
                    else {
                        returnedValues.push(rctx.context_values);
                    }
                }
            }
        });
        if (this.isDistinct()) {
            returnedValues = toDistinctList(returnedValues);
        }
        if (this.aggregateClause != null) {
            returnedValues = this.aggregateClause.aggregate(returnedValues, ctx);
        }
        if (this.sortClause != null) {
            this.sortClause.sort(ctx, returnedValues);
        }
        if (this.sources.returnsList() || this.aggregateClause != null) {
            return returnedValues;
        }
        else {
            return returnedValues[0];
        }
    };
    return Query;
}(expression_1.Expression));
exports.Query = Query;
var AliasRef = /** @class */ (function (_super) {
    __extends(AliasRef, _super);
    function AliasRef(json) {
        var _this = _super.call(this, json) || this;
        _this.name = json.name;
        return _this;
    }
    AliasRef.prototype.exec = function (ctx) {
        return ctx != null ? ctx.get(this.name) : undefined;
    };
    return AliasRef;
}(expression_1.Expression));
exports.AliasRef = AliasRef;
var QueryLetRef = /** @class */ (function (_super) {
    __extends(QueryLetRef, _super);
    function QueryLetRef(json) {
        return _super.call(this, json) || this;
    }
    return QueryLetRef;
}(AliasRef));
exports.QueryLetRef = QueryLetRef;
// The following is not defined by ELM but is helpful for execution
var MultiSource = /** @class */ (function () {
    function MultiSource(sources) {
        this.sources = sources;
        this.alias = this.sources[0].alias;
        this.expression = this.sources[0].expression;
        this.isList = true;
        if (this.sources.length > 1) {
            this.rest = new MultiSource(this.sources.slice(1));
        }
    }
    MultiSource.prototype.aliases = function () {
        var a = [this.alias];
        if (this.rest) {
            a = a.concat(this.rest.aliases());
        }
        return a;
    };
    MultiSource.prototype.returnsList = function () {
        return this.isList || (this.rest && this.rest.returnsList());
    };
    MultiSource.prototype.forEach = function (ctx, func) {
        var _this = this;
        var records = this.expression.execute(ctx);
        this.isList = (0, util_1.typeIsArray)(records);
        records = this.isList ? records : [records];
        return records.map(function (rec) {
            var rctx = new context_1.Context(ctx);
            rctx.set(_this.alias, rec);
            if (_this.rest) {
                return _this.rest.forEach(rctx, func);
            }
            else {
                return func(rctx);
            }
        });
    };
    return MultiSource;
}());
//# sourceMappingURL=query.js.map